"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIUpdateLeadBody = void 0;
const iclient_entity_1 = require("./iclient-entity");
function parseIUpdateLeadBody(data) {
    if (data.lead !== null && typeof data.lead === 'object')
        data.lead = (0, iclient_entity_1.parseIClientEntity)(data.lead);
    return data;
}
exports.parseIUpdateLeadBody = parseIUpdateLeadBody;
